import { memo } from 'react';
import { Star } from 'react-feather';
import styled from '@emotion/styled';

type Props = {
  className?: string;
  /** Without it the star is a read-only indicator. */
  onClick?: () => void;
  value: boolean;
};

const StarToggle = memo(({
  className,
  onClick,
}: Props) => {

  return (
    <Star
      className={className}
      onClick={onClick} />
  );
});

const StyledStarToggle = styled(StarToggle)(({ theme, value, onClick }) => ({
  cursor: onClick ? 'pointer' : 'default',
  strokeWidth: 1,

  color: value ? 'gold' : theme.palette.gray.light1,
  fill: value ? 'gold' : undefined,

  '&:hover': onClick
    ? {
        color: 'gold',
        fill: value ? 'gold' : '#FFF6C9',
      }
    : undefined,
}));

export { StyledStarToggle as StarToggle };